import { API_BASE_URL } from './client';

// Cloud Providers API
export const getCloudCatalogProviders = async (keycloak, search = '') => {
  if (!keycloak || !keycloak.authenticated) {
    throw new Error('Not authenticated');
  }
  try {
    const params = new URLSearchParams();
    if (search) params.append('search', search);
    const response = await fetch(`${API_BASE_URL}/cloud-providers/catalog/providers/?${params.toString()}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${keycloak.token}`,
      },
    });
    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
    return await response.json();
  } catch (error) {
    console.error('Error fetching cloud catalog providers:', error);
    return [];
  }
};

export const getCloudCatalogModels = async (keycloak, providerKey, search = '', mode = 'chat') => {
  if (!keycloak || !keycloak.authenticated) {
    throw new Error('Not authenticated');
  }
  try {
    const params = new URLSearchParams();
    if (search) params.append('search', search);
    if (mode) params.append('mode', mode);
    const response = await fetch(`${API_BASE_URL}/cloud-providers/catalog/providers/${providerKey}/models/?${params.toString()}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${keycloak.token}`,
      },
    });
    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
    return await response.json();
  } catch (error) {
    console.error('Error fetching cloud catalog models:', error);
    return [];
  }
};

export const syncCloudCatalog = async (keycloak) => {
  if (!keycloak || !keycloak.authenticated) {
    throw new Error('Not authenticated');
  }
  const response = await fetch(`${API_BASE_URL}/cloud-providers/catalog/sync/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${keycloak.token}`,
    },
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Failed to sync catalog');
  }
  return await response.json();
};

export const getUserCloudProviders = async (keycloak) => {
  if (!keycloak || !keycloak.authenticated) {
    throw new Error('Not authenticated');
  }
  try {
    const response = await fetch(`${API_BASE_URL}/cloud-providers/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${keycloak.token}`,
      },
    });
    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
    return await response.json();
  } catch (error) {
    console.error('Error fetching user cloud providers:', error);
    return [];
  }
};

export const createCloudProvider = async (keycloak, data) => {
  if (!keycloak || !keycloak.authenticated) {
    throw new Error('Not authenticated');
  }
  const response = await fetch(`${API_BASE_URL}/cloud-providers/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${keycloak.token}`,
    },
    body: JSON.stringify(data),
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Failed to create cloud provider');
  }
  return await response.json();
};

export const updateCloudProvider = async (keycloak, providerId, data) => {
  if (!keycloak || !keycloak.authenticated) {
    throw new Error('Not authenticated');
  }
  const response = await fetch(`${API_BASE_URL}/cloud-providers/${providerId}/`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${keycloak.token}`,
    },
    body: JSON.stringify(data),
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Failed to update cloud provider');
  }
  return await response.json();
};

export const deleteCloudProvider = async (keycloak, providerId) => {
  if (!keycloak || !keycloak.authenticated) {
    throw new Error('Not authenticated');
  }
  const response = await fetch(`${API_BASE_URL}/cloud-providers/${providerId}/`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${keycloak.token}`,
    },
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Failed to delete cloud provider');
  }
  return await response.json();
};
export const testCloudProvider = async (keycloak, providerId) => {
  if (!keycloak || !keycloak.authenticated) {
    throw new Error('Not authenticated');
  }
  const response = await fetch(`${API_BASE_URL}/cloud-providers/${providerId}/test/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${keycloak.token}`,
    },
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Failed to test cloud provider');
  }
  return await response.json();
};
